import { render, staticRenderFns } from "./Simulations.vue?vue&type=template&id=33adbdd9&scoped=true"
import script from "./Simulations.vue?vue&type=script&lang=js"
export * from "./Simulations.vue?vue&type=script&lang=js"
import style0 from "./Simulations.vue?vue&type=style&index=0&id=33adbdd9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33adbdd9",
  null
  
)

export default component.exports